module.exports = __webpack_public_path__ + "static/media/icon-user.68558db5.svg";